import React, { useState } from "react";
import styles from "./SmartText.module.scss";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

interface Props {
  text: string;
  length: number;
}

const SmartText: React.FC<Props> = ({ text, length }) => {
  const [showLess, setShowLess] = useState(true);

  if (text.length < length) {
    return <div>{text}</div>;
  }

  return (
    <div>
      <div>{showLess ? `${text.slice(0, length)}...` : text}</div>
      <a className={styles.linqView} onClick={() => setShowLess(!showLess)}>
        &nbsp;View {showLess ? "More" : "Less"} {showLess ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </a>
    </div>
  );
};

export default SmartText;